import {apiAxios} from "@/service/APIClient";
import LiveWinDTO from "@/models/LiveWinDTO";
import TournamentDTO from "@/models/TournamentDTO";

export const live = {
    wins: async (): Promise<LiveWinDTO[]> => {
        let resp = await apiAxios({
            url: `/live/wins`,
            method: 'GET',
        })

        return resp.data as LiveWinDTO[]
    },
    tournaments: async (): Promise<TournamentDTO[]> => {
        let resp = await apiAxios({
            url: `/live/tournaments`,
            method: 'GET',
        })

        return resp.data as TournamentDTO[]
    },
}